import { Link } from 'react-router-dom';
import { categories, articles } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            内容分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            六大内容板块，从入门到精通，系统化学习捆绑调教的方方面面
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => {
            const count = articles.filter((a) => a.category === cat.slug).length;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-background-300/60 transition-all duration-300 cursor-pointer"
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl bg-${cat.color === 'accent' ? 'accent' : cat.color === 'primary' ? 'primary' : 'secondary'}-100 text-${cat.color === 'accent' ? 'accent' : cat.color === 'primary' ? 'primary' : 'secondary'}-700 mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {cat.description}
                </p>
                <span className="text-xs text-foreground-400">
                  {count} 篇文章
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}